import React from 'react';

import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ConnectedAllServerUsersSpace } from './ConnectedAllServerUsersSpace';

export interface AllServerUsersSpaceProviderProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

interface AllServerUsersSectionProviderProps extends AllServerUsersSpaceProviderProps {
}

const AllServerUsersSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'serverusers',
  subspaceName: undefined
};

const AllServerUsersSectionProvider: React.FunctionComponent<AllServerUsersSectionProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllServerUsersSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedAllServerUsersSpace shouldRenderAsSubspace={false}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export const AllServerUsersSpaceProvider: React.FunctionComponent<AllServerUsersSpaceProviderProps> = (props) => {
  return <AllServerUsersSectionProvider {...props}/>;
};

